module.exports = __webpack_public_path__ + "img/73.e316948b.jpg";